import { computed, get } from '@ember/object';

export default function slice(dependentKey, begin, end) {
  return computed(`${dependentKey}.[]`, function () {
    return get(this, dependentKey).slice(begin, end);
  });
}
